module.exports = __webpack_public_path__ + "img/shape2.91d65fc2.svg";